import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07a8f5e0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a8f5e0')) {
      api.createRecord('07a8f5e0', component.options)
    } else {
      api.reload('07a8f5e0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=07a8f5e0&", function () {
      api.rerender('07a8f5e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/brb-uploader/index.vue"
export default component.exports